module.exports = __webpack_public_path__ + "img/dk.eb1416e0.svg";